/**
 * Reader-facing markdown of a workflow spec: without the leading YAML front matter
 * (ids, status) and the `<!-- @id ... -->` annotations the spec carries. The spec
 * already opens with `# <name>`.
 *
 * @module features/proofs/hooks/specMarkdown
 */
const FRONT_MATTER = /^---\r?\n[\s\S]*?\r?\n---(?:\r?\n|$)/;
const ANNOTATION = / *<!--\s*@\w+[^>]*?-->/g;

export function toReaderMarkdown(spec: string): string {
  return spec
    .replace(FRONT_MATTER, '')
    .replace(ANNOTATION, '')
    .replace(/(?:\r?\n){3,}/g, '\n\n')
    .trim();
}
